module.exports = __webpack_public_path__ + "img/LUB00394.4aa7230c.png";